import React, {useEffect} from 'react';
import {NavigationContainer} from '@react-navigation/native';
import {createStackNavigator} from '@react-navigation/stack';
import {
    PreviewDashboardPage,
    PreviewPostDetailPage,
    ProductBasketPage,
} from '@redlink/components/pages';
import {useValues} from '@redlink/assets/values';
import {useLocale} from "@redlink/assets/locale";

const MainStack = createStackNavigator();

export const Route = () => {
    const {routes} = useValues();
    const {setLayout} = useLocale();

    useEffect(() => {
        setLayout()
    }, [setLayout]);

    const linking = {
        prefixes: ['https://redl.ink'],
        config: {
            screens: {
                Preview: {
                    path: routes.preview.name,
                    screens: {
                        PreviewLink: routes.previewLink.name,
                        PreviewProfile: routes.previewProfile.name,
                        PreviewShop: routes.previewShop.name,
                        PreviewGallery: routes.previewGallery.name,
                        PreviewResume: routes.previewResume.name,
                    },
                },
                PreviewPostDetail: routes.previewPostDetail.name,
                ProductBasket: routes.productBasket.name,
            },
        },
    };

    return (
        <NavigationContainer {...{linking}}>
            <MainStack.Navigator
                screenOptions={{
                    animationEnabled: false,
                    headerShown: false,
                }}
            >
                <MainStack.Screen
                    name={routes.preview.key}
                    component={PreviewDashboardPage}
                />
                <MainStack.Screen
                    name={routes.previewPostDetail.key}
                    component={PreviewPostDetailPage}
                />
                <MainStack.Screen
                    name={routes.productBasket.key}
                    component={ProductBasketPage}
                />
            </MainStack.Navigator>
        </NavigationContainer>
    );
};
